export default [
  {
    path: '/categorylist',
    name: 'categorylist',
    meta: {
      index: 2
    },
    component: () =>
      import('@/pages/categorylist/index.vue')
  },
  {
    path: '/search',
    name: 'search',
    meta: {
      index: 2
    },
    component: () =>
      import('@/pages/search/index.vue')
  }
]
